import type { AccountColumn } from './accountTables';
import { formatSubscriptionStatus } from './accountTables';
import { formatInt } from './format';

export type InactivityKind = 'login' | 'lancamento';

export const DEFAULT_INACTIVITY_DAYS = 30;
export const MIN_INACTIVITY_DAYS = 1;
export const MAX_INACTIVITY_DAYS = 365;

/** Inteiro de 1 a 365, como o back-end aceita. Fora disso, nao consulta. */
export function parseDays(raw: string): number | null {
    if (!/^\d+$/.test(raw.trim())) return null;
    const n = Number(raw);
    return n >= MIN_INACTIVITY_DAYS && n <= MAX_INACTIVITY_DAYS ? n : null;
}

/** "6 contas há pelo menos 30 dias sem acesso." */
export function inactivitySummary(count: number, days: number, kind: InactivityKind): string {
    const what = kind === 'login' ? 'acesso' : 'lançamento';
    return `${formatInt(count)} ${count === 1 ? 'conta há' : 'contas há'} pelo menos ${formatInt(days)} ${days === 1 ? 'dia' : 'dias'} sem ${what}.`;
}

export const INACTIVE_COLUMNS: AccountColumn[] = [
    { key: 'conta', label: 'Cliente' },
    { key: 'email', label: 'E-mail' },
    { key: 'assinatura', label: 'Assinatura' },
    { key: 'ultimoLogin', label: 'Último acesso' },
    { key: 'ultimoLancamento', label: 'Último lançamento' },
    { key: 'nuncaFezLogin', label: 'Acesso' },
    { key: 'nuncaLancou', label: 'Lançamento' },
    { key: 'diasSemLogin', label: 'Dias sem acesso' },
    { key: 'diasSemLancamento', label: 'Dias sem lançamento' },
];

export const INACTIVE_FORMATTERS = {
    assinatura: formatSubscriptionStatus,
    nuncaFezLogin: (v: unknown) => (v === true ? 'Nunca acessou' : 'Já acessou'),
    nuncaLancou: (v: unknown) => (v === true ? 'Nunca lançou' : 'Já lançou'),
};
